/* Domovoi · the sign-in and join pages' plum panel (the redesign): the line beside the form, and which kind of page
   it is. Pure: the pages call it as their screen changes. */
/** heroSay('Welcome back.', { step: 'Step 1 of 3', mode: 'gone' | 'small' | 'forgot' })
    forgot: the domovoi confused on a computer, and no plum at all on a phone; gone: the whole page plum, the domovoi
    waving goodbye; small: no drawing on a phone (join's later steps). */
const FIG = { forgot: 'au-cf', gone: 'au-fw' };
export function heroSay(text, { step = '', mode = '' } = {}) {
  if (typeof document === 'undefined') return;
  const say = document.getElementById('au-say');
  if (say && text != null) say.textContent = text;
  const st = document.getElementById('au-step');
  if (st) st.textContent = step;
  const au = document.querySelector('.au');
  if (au) {
    if ((au.getAttribute('data-mode') || '') === mode) return;
    if (mode) au.setAttribute('data-mode', mode); else au.removeAttribute('data-mode');
  }
  const fig = FIG[mode] && document.getElementById(FIG[mode]);   // plays once each time it comes into view
  if (fig) { fig.classList.remove('play'); void fig.offsetWidth; fig.classList.add('play'); }
}
